import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './connection.reducer';

export const ConnectionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const connectionEntity = useAppSelector(state => state.connection.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="connectionDetailsHeading">
          <Translate contentKey="fivePlusApp.connection.detail.title">Connection</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{connectionEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="fivePlusApp.connection.status">Status</Translate>
            </span>
          </dt>
          <dd>{connectionEntity.status}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.connection.userMentor">User Mentor</Translate>
          </dt>
          <dd>{connectionEntity.userMentor ? connectionEntity.userMentor.id : ''}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.connection.userMentee">User Mentee</Translate>
          </dt>
          <dd>{connectionEntity.userMentee ? connectionEntity.userMentee.id : ''}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.connection.question">Question</Translate>
          </dt>
          <dd>
            {connectionEntity.questions
              ? connectionEntity.questions.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {connectionEntity.questions && i === connectionEntity.questions.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/connection" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/connection/${connectionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConnectionDetail;
